import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App";
import router from "./router";
// import VueRouter from 'vue-router'
import axios from "axios";
import store from "./store";
import scroller from "vue-scroller";
import "font-awesome/scss/font-awesome.scss";
import "./assets/style/reset.css";
import "./assets/style/mainstyle.css";
import tabbar from "./components/tabBar";
import swiper from "./components/swiper";
import float from "./components/float";
import activitylist from "./components/activityList";
import infolist from "./components/infoList";
import personalinfo from "./components/personalInfo";
import qrcode from "./components/qrCode";
import QRCode from "qrcodejs2";
import { Popup } from "mint-ui";
import VueCookie from "vue-cookie";

Vue.use(VueCookie);
Vue.config.productionTip = false;
Vue.config.devtools = true;

Vue.prototype.$axios = axios;
// axios.defaults.baseURL='/api';
// Vue.prototype.HOST='/api';
Vue.use(ElementUI);
Vue.use(scroller);
Vue.use(tabbar);
Vue.use(swiper);
Vue.use(float);
Vue.use(activitylist);
Vue.use(infolist);
Vue.use(personalinfo);
Vue.use(router);
Vue.use(qrcode);
// Vue.component("qrcode",qrcode)
Vue.prototype.$qrCode = QRCode;
Vue.component(Popup.name, Popup);

// Vue.use(VueRouter)//  如果使用模块化机制编程，导入Vue和VueRouter，要调用 Vue.use(VueRouter)

// // 创建 router 实例，然后传 `routes` 配置
// const router = new VueRouter({
//   routes,// (缩写) 相当于 routes: routes
//   mode: routerMode,
//   strict: process.env.NODE_ENV !== 'production',
//   scrollBehavior (to, from, savedPosition) {
//     if (savedPosition) {
//       return savedPosition
//     } else {
//       if (from.meta.keepAlive) {
//         from.meta.savedPosition = document.body.scrollTop;
//       }
//       return { x: 0, y: to.meta.savedPosition || 0 }
//     }
//   }
// })

// 创建和挂载根实例。
// 记得要通过 router 配置参数注入路由，
// 从而让整个应用都有路由功能
new Vue({
  router,
  store,
  components: { App },
  render: h => h(App)
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js